<script>
import {mapGetters} from "vuex";
import OrganizationsByRegionLabels
  from "@/components/modules/new-dashboard/components/organizations-by-region/organizations-by-region-labels.vue";
import DonutChart from "@/shared/charts/donut-chart/donut-chart.vue";
import OrganizationsByEconomicActivityLabels
  from "@/components/modules/new-dashboard/components/organizations-by-economic-activity/organizations-by-economic-activity-labels.vue";
import TrackerOrganizationsByEconomicActivityLabels
  from "@/components/modules/tracker-dashboard/components/tracker-organizations-by-economic-activity/tracker-organizations-by-economic-activity-labels.vue";
import DashboardSpinner from "@/components/modules/new-dashboard/components/dashboard-spinner.vue";
import BarChart from "@/shared/charts/bar-char/bar-chart.vue";
import DashboardNoData from "@/components/modules/new-dashboard/components/dashboard-no-data.vue";

export default {
  name: 'TrackerOrganizationsByEconomyActivity',
  components: {DashboardNoData, BarChart, DashboardSpinner, TrackerOrganizationsByEconomicActivityLabels, DonutChart},
  data: function () {
    return {
      groups: [],
      formattedOrganizations: [],
      config: {
        width: 400,
        height: 260,
        marginTop: 70,
        marginBottom: 70,
      },
      colors: {
        optionList_selfAssessment_general_classification_activityAggregated_agriculture_short : "#19A39C",
        optionList_selfAssessment_general_classification_activityAggregated_manufacturing_short  : "#F32474",
        optionList_selfAssessment_general_classification_activityAggregated_construction_short : "#B7C51C",
        optionList_selfAssessment_general_classification_activityAggregated_minesEnergyWater_short: "#22C2E5",
        optionList_selfAssessment_general_classification_activityAggregated_trade_short : "#FCA71C",
        optionList_selfAssessment_general_classification_activityAggregated_transport_short : "#CE51BF",
        optionList_selfAssessment_general_classification_activityAggregated_hospitalityFood_short: "#2AA816",
        optionList_selfAssessment_general_classification_activityAggregated_businessAdmin_short : "#8819A3",
        optionList_selfAssessment_general_classification_activityAggregated_publicAdmin_short : "#2F60A6",
        optionList_selfAssessment_general_classification_activityAggregated_socialCommunity_short:"#EAD325",
        optionList_selfAssessment_general_classification_activityAggregated_financialServices_short:"#EAD325",
        optionList_selfAssessment_general_classification_activityAggregated_Education_short:"#EAD325",
        optionList_selfAssessment_general_classification_activityAggregated_telecommunications_short:"#EAD325",
        optionList_selfAssessment_general_classification_activityAggregated_informationTechnology_short:"#EAD325",
      },
    }
  },
  watch: {
    getTrackerOrganizationsByEconomicActivity: {
      handler: function () {
        this.formatOrganizationsByEconomicActivity();
      }, deep: true
    }
  },
  mounted() {
    this.formatOrganizationsByEconomicActivity();
  },
  computed: {
    ...mapGetters(["getTrackerOrganizationsByEconomicActivity"])
  },
  methods: {
    hasData: function () {
      return !!this.formattedOrganizations.filter((s) => !!s.value).length;
    },
    formatOrganizationsByEconomicActivity: function () {
      var totals = this.getTrackerOrganizationsByEconomicActivity.data.reduce(
        (previousValue, currentValue) => previousValue + +currentValue.count,
        0,
      );

var filtered = this.getTrackerOrganizationsByEconomicActivity.data.filter(org => !!org._id && Object.keys(this.colors).includes(`${org._id}_short`));
if(filtered.length < this.getTrackerOrganizationsByEconomicActivity.data.length) {
  var missing = this.getTrackerOrganizationsByEconomicActivity.data.filter(org => !!org._id && !Object.keys(this.colors).includes(`${org._id}_short`)).map(org => org._id);
  console.error(`missing ${this.getTrackerOrganizationsByEconomicActivity.data.length - filtered.length} organizations to be mapped: ${missing}`);
}
      this.formattedOrganizations = filtered.filter((val)=>!!val.count).map((org) => {
        var shortName = `${org._id}_short`
        return {
          label: this.$t(shortName),
          value: org.count,
          color: this.colors[shortName],
          percentage: (totals > 0 ? (100 * org.count / totals).toFixed() : 0)+'%',
          originalName: org._id,
        };

      });
      this.groups = this.formattedOrganizations.map(org => org.label)
    },
  }
}

</script>

<template>
  <div>
    <dashboard-spinner :height="260" v-if="getTrackerOrganizationsByEconomicActivity.loading"></dashboard-spinner>

    <dashboard-no-data :height="260"
                       v-if="!hasData() && !getTrackerOrganizationsByEconomicActivity.loading"></dashboard-no-data>

    <div
      v-if="hasData() && !getTrackerOrganizationsByEconomicActivity.loading"
      class="public-institutions-by-sector"
      style="cursor: pointer;width:100%"

    >
      <bar-chart
        :chart-data="formattedOrganizations"
        :colors="colors"
        :config="config"
        :parent-height="false"
        :custom-group-sorting="groups"
      />
    </div>
  </div>
</template>

<style scoped>
.public-institutions-by-region {
  display: flex;
}

.public-institutions-by-area {
  position: relative;
  top: -10px
}

.public-institutions-by-country {
  position: absolute;
  top: 0;
  left: 0;
}

.loading {
  height: 236px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style lang="scss">
.public-institutions-by-area-modal-container {
  height: 100%;

  .public-institutions-by-region, .public-institutions-by-country {
    height: 100%;
    width: 100%;
    align-items: center;
  }

  .donut-chart-svg {
    min-width: 100px;
    height: 100%;
  }

  .region-labels-container {
    height: 100%;
    align-items: center;

    .region-label-container {

      .region-label-name {
        font-size: 1.5vw !important;
        min-width: 12vw !important;
        max-width: 12vw !important;
        flex-basis: 15vw !important;
      }

      .region-label-value {
        font-size: 1.5vw !important;
        min-width: 5vw !important;
        max-width: 5vw !important;
        flex-basis: 15vw !important;
      }

      .region-label-color {
        width: 1.5vw !important;
        height: 1.5vw !important;
      }
    }
  }
}
</style>
